import { LuRocket, LuX } from 'react-icons/lu';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '@/components/ui/dialog';

interface PortfolioBoostCardProps {
    enrollmentPath: string;
    onDismiss: () => void;
}

export const PortfolioBoostCard = ({ enrollmentPath, onDismiss }: PortfolioBoostCardProps) => (
    <Card className="flex min-h-[32rem] flex-col rounded-2xl border-0 bg-[#2b2422] p-4 text-white lg:p-8">
        <div className="flex items-center justify-between gap-4">
            <h2 className="inline-flex items-center gap-2 rounded-md bg-white/10 px-3 py-2 text-xs font-medium tracking-wider uppercase">
                <LuRocket className="h-4 w-4" />
                Portfolio Boost
            </h2>
            <button
                type="button"
                onClick={onDismiss}
                aria-label="Dismiss Portfolio Boost"
                className="cursor-pointer rounded-md p-2 text-white/70 hover:bg-white/10 hover:text-white focus-visible:outline-2 focus-visible:outline-white"
            >
                <LuX className="h-4 w-4" />
            </button>
        </div>
        <p className="mt-16 text-sm leading-relaxed text-white/80">
            On the engine it stays on target every trading day — rebalancing, building cash, and loss harvesting all run
            automatically.
        </p>
        <div className="mt-auto flex flex-wrap gap-3 border-t border-white/15 pt-5">
            <Button asChild className="rounded-lg bg-white text-[#2b2422] hover:bg-white/90">
                <Link to={enrollmentPath}>
                    <LuRocket className="mr-2 h-4 w-4" />
                    Enroll in Boost
                </Link>
            </Button>
            <Dialog>
                <DialogTrigger asChild>
                    <Button
                        variant="outline"
                        className="rounded-lg border-white/25 bg-transparent text-white hover:bg-white/10 hover:text-white"
                    >
                        Learn more
                    </Button>
                </DialogTrigger>
                <DialogContent>
                    <DialogHeader>
                        <DialogTitle>Portfolio Boost</DialogTitle>
                        <DialogDescription>
                            Portfolio Boost uses automatic account management to keep investments aligned with a target
                            allocation.
                        </DialogDescription>
                    </DialogHeader>
                    <p className="text-cocoa-600 text-sm leading-relaxed">
                        The portfolio engine manages rebalancing and cash needs, with tax-loss harvesting when enabled.
                        To enroll, open the portfolio overview and review the portfolio’s management and target
                        allocation setup before making changes.
                    </p>
                    <Button asChild>
                        <Link to={enrollmentPath}>Open portfolio overview</Link>
                    </Button>
                </DialogContent>
            </Dialog>
        </div>
    </Card>
);
